module.exports = __webpack_public_path__ + "img/PL08838.53f01a25.png";